import './App.scss';
import Calculator from './components/Calculator';
import Estimation from './components/Estimation';
import Details from './components/Details';
import { useState } from 'react';
import cn from 'classnames';

const  App = () => {
  const [labels, setLabels]  =  useState(null)
  const [responsesByDate, setResponsesByDate]  =  useState(null)
  const [weekAcceptData, setWeekAcceptData]  =  useState(null)
  const [weekDeclineData, setWeekDeclineData]  =  useState(null)
  const [isDetails, setIsDetails] = useState(false)

  const handleCalculate = (labels, responsesByDate, weekAcceptData, weekDeclineData) => {
    setLabels(labels);
    setResponsesByDate(responsesByDate);
    setWeekAcceptData(weekAcceptData);
    setWeekDeclineData(weekDeclineData);
    setIsDetails(true)
  }

  return (
    <div className='timeline-calculator'>
      <div className='timeline-calculator__wrapper'>
        <Calculator onCalculate={handleCalculate}/>
        <div className='timeline-calculator__divider'></div>
        <Estimation responsesByDate={responsesByDate} acceptData={weekAcceptData} declineData={weekDeclineData}/>
      </div>
      <div className={cn('timeline-calculator__details', isDetails && 'timeline-calculator__details_visible')}>
        <Details labels={labels} acceptData={weekAcceptData} declineData={weekDeclineData}/>
      </div>
    </div>
  );
}

export default App;
